module.exports = __webpack_public_path__ + "img/tag_business_only@2x.be4d056e.png";